export const AttributeStructureType = {
  Qualitative: "qualitative",
  MedicalAlternatives: "medicalAlternatives",
  StudyDesign: "studyDesign",
} as const;

export type AttributeStructureType =
  (typeof AttributeStructureType)[keyof typeof AttributeStructureType];
